document.addEventListener('DOMContentLoaded', () => {
	const collectionGrid = document.querySelector('.collection__products');
	const productItem = collectionGrid.querySelectorAll('.product-item');
	const itemsArray = Array.from(productItem).map((item) => {
		const eventDetail = item.dataset;
		return formatDataLayerObject('view_item_list', eventDetail).ecommerce.items[0];
	});

	if (itemsArray.length > 0) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'view_item_list',
			ecommerce: {
				items: itemsArray,
			},
		});
	}
});
